export default __webpack_public_path__ + "static/media/agriculture.97068a59.jpg";